import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CardContent,
  Box,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

function MaterialsSummary({ command, deliveryOrders }) {
  const { t } = useTranslation('order_detail')
  const [plannedMaterials, setPlannedMaterials] = useState([])
  const [toBePlannedMaterials, setToBePlannedMaterials] = useState([])
  const [plannedRubbles, setPlannedRubbles] = useState([])
  const [toBePlannedRubbles, setToBePlannedRubbles] = useState([])

  let commandMaterials =
    command?.command.commandMaterials.edges
      .filter(({ node }) => node.material.productCategoryByIdProductCategory.family === 'MATERIAL')
      .map(({ node }) => ({
        id: node.id,
        commandMaterialId: node.commandId,
        materialId: node.material.id,
        description: node.material.description,
        baseMeasureUnitCode: node.material.measureUnitByBaseMeasureUnitCode.abbr,
        internalId: node.material.internalId,
        unit: node.material.measureUnitByBaseMeasureUnitCode.abbr,
        totalQuantity: node.quantity,
      })) || []

  let commandRubbles =
    command?.command.commandMaterials.edges
      .filter(({ node }) => node.material.productCategoryByIdProductCategory.family === 'RUBBLE')
      .map(({ node }) => ({
        id: node.id,
        commandMaterialId: node.commandId,
        materialId: node.material.id,
        description: node.material.description,
        baseMeasureUnitCode: node.material.measureUnitByBaseMeasureUnitCode.abbr,
        internalId: node.material.internalId,
        unit: node.material.measureUnitByBaseMeasureUnitCode.abbr,
        totalQuantity: node.quantity,
      })) || []

  useEffect(() => {
    const deliveredQuantities =
      deliveryOrders?.length > 0
        ? deliveryOrders.reduce((acc, delivery) => {
            delivery.allMaterials?.forEach((material) => {
              if (!acc[material.internalId]) {
                acc[material.internalId] = { ...material, deliveredQuantity: 0 }
              }
              acc[material.internalId].deliveredQuantity += +material.quantity
            })
            return acc
          }, {})
        : {}

    const plannedMaterials = []
    const toBePlannedMaterials = []
    const plannedRubbles = []
    const toBePlannedRubbles = []

    // Process materials
    commandMaterials.forEach((material) => {
      const delivered = deliveredQuantities[material.internalId]?.deliveredQuantity || 0
      const remainingQuantity = +material.totalQuantity - delivered

      if (delivered > 0) {
        plannedMaterials.push({
          ...material,
          deliveredQuantity: delivered,
        })
      }

      if (remainingQuantity > 0) {
        toBePlannedMaterials.push({
          ...material,
          remainingQuantity,
        })
      }
    })

    // Process rubbles
    commandRubbles.forEach((rubble) => {
      const delivered = deliveredQuantities[rubble.internalId]?.deliveredQuantity || 0
      const remainingQuantity = +rubble.totalQuantity - delivered

      if (delivered > 0) {
        plannedRubbles.push({
          ...rubble,
          deliveredQuantity: delivered,
        })
      }

      if (remainingQuantity > 0) {
        toBePlannedRubbles.push({
          ...rubble,
          remainingQuantity,
        })
      }
    })

    setPlannedMaterials(plannedMaterials)
    setToBePlannedMaterials(toBePlannedMaterials)
    setPlannedRubbles(plannedRubbles)
    setToBePlannedRubbles(toBePlannedRubbles)
  }, [command, deliveryOrders])

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" gap="16px">
          <CardContent style={{ border: '2px solid green', flex: 1 }}>
            <h4>{t('plannedMaterials')}</h4>
            {plannedMaterials.length > 0 || plannedRubbles.length > 0 ? (
              <ul>
                {plannedMaterials.map((material) => (
                  <li key={material.internalId}>
                    {material.description}: {material.deliveredQuantity} {material.unit}
                  </li>
                ))}
                {plannedRubbles.map((rubble) => (
                  <li key={rubble.internalId}>
                    {rubble.description}: {rubble.deliveredQuantity} {rubble.unit}
                  </li>
                ))}
              </ul>
            ) : (
              <p>{t('notPlanned')}</p>
            )}
          </CardContent>
          <CardContent style={{ border: '2px solid red', flex: 1 }}>
            <h4>{t('toBePlannedMaterials')}</h4>
            {toBePlannedMaterials.length > 0 || toBePlannedRubbles.length > 0 ? (
              <ul>
                {toBePlannedMaterials.map((material) => (
                  <li key={material.internalId}>
                    {material.description}: {material.remainingQuantity} {material.unit} {t('remaining')}
                  </li>
                ))}
                {toBePlannedRubbles.map((rubble) => (
                  <li key={rubble.internalId}>
                    {rubble.description}: {rubble.remainingQuantity} {rubble.unit} {t('remaining')}
                  </li>
                ))}
              </ul>
            ) : (
              <p>{t('allPlanned')}</p>
            )}
          </CardContent>
        </Box>
      </CardContent>
    </Card>
  )
}

MaterialsSummary.propTypes = {
  command: PropTypes.any,
  deliveryOrders: PropTypes.any,
}

export default MaterialsSummary